import { Builder } from '@builder.io/react';

import UnstyledSMID from './unstyled-smid';

Builder.registerComponent(UnstyledSMID, {
  name: 'UnstyledSMID',
  noWrap: true,
  friendlyName: 'Unstyled SMID',
});
